<template>
    <mm-tab-title>
        <el-button slot="save" size="medium" type="primary" @click="submit">Test</el-button>
        <div>
        <el-form ref="form" size="small" label-width="200px">
            <el-form-item label="Test Link" prop="link">
                <el-input v-model="test_link"/>
            </el-form-item>
            <el-form-item label="Country">
                <el-input v-model="country"/>
            </el-form-item>
            <el-form-item label="OS" prop="os">
                <el-radio-group v-model="os">
                    <el-radio label='1'>IOS</el-radio>
                    <el-radio label='2'>Android</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="Zone" prop="zone">
                <el-radio-group v-model="zone">
                    <el-radio label='0'>3G/4G</el-radio>
                    <el-radio label='1'>WIFI</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="Redirection history" prop="history"  >
                <el-input v-model="history" type="textarea" :rows="6" />
            </el-form-item>
            <el-form-item label="Use Time" prop="time"  >
                <el-input v-model="use_time" :readonly="true"/>
            </el-form-item>
        </el-form>

        </div>
    </mm-tab-title>


</template>

<script>
export default {
	data() {
		return {
            test_link: '',
            country: '',
            os: '1',
            zone: '1',
            use_time: '',
            history: '',
        };
	},
	methods: {
		async submit() {
            if (this.test_link === '' || this.country === '') {
                this.$message({
                    type: 'error',
                    message: 'Missing Parameter'
                });
            }
            this.history = '';
            const url = `https://api.trailmi.com/track?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjEwMDAzfQ.KQpn971Dkv8rC1AzR1WgN0VLsQkVunk42EnBLY3G-Bs&country=${this.country}&os=${this.os}&zone=${this.zone}&url=${encodeURIComponent(this.test_link)}`;
            const result = await this.$post('/postback/jump',{ url });
            if (result.data) {
                const urls = result.data.result.urls || {};
                for (const url of urls) {
                    if (url.url) {
                        this.history += url.url + '\n' + '\n';
                    }
                }
                this.use_time = result.data.result.delta + 'ms';
            } else {
                this.history = result;
            }
		},
	},
};
</script>